import script from "./notify-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./notify-settings.vue?vue&type=script&setup=true&lang=ts"

import "./notify-settings.vue?vue&type=style&index=0&id=e65f60c2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e65f60c2"]])

export default __exports__